import { Component, inject, Optional } from '@angular/core';
import { DokItemInfo } from '@app/components/dokumentacija/dokumentacija-types';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import {
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';
import { combineLatest, map } from 'rxjs';
import { DokumentacijaOpenItemViewActionComponent } from './openitemview-dokumentacija';
import { updateItemWithFreshParent } from './dokumentacija-utils';

@Component({
  selector: 'app-new-predmet-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class NewPredmetActionComponent extends DokumentacijaOpenItemViewActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    @Optional() protected override itemProvider: ItemProvider,
    protected listViewProvider: ListViewProviderDirective<ListView>
  ) {
    super(notificationService, windowRegistry, window, itemProvider);
  }

  private parentListViewProvider = inject(ParentListViewProvider);

  protected override isDisabled(dokInfo: DokItemInfo): boolean {
    return dokInfo.parent?.locked === true;
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = combineLatest([
      this.itemProvider.item$,
      this.parentListViewProvider.selectedItems$
    ]).pipe(
      map(([item, selectedParentItems]: [any, any]) => {
        const dokInfo = updateItemWithFreshParent(item, selectedParentItems);
        return this.isDisabled(dokInfo);
      })
    );
  }
}
